export default __webpack_public_path__ + "static/media/FP_Logo_Black.90430643.svg";